export default class pickupLogic {
	earliest = new Date();
	latest = new Date();
	pluck = (arr, key) =>
		arr
			.filter(function (date) {
				return date.validPickup;
			})
			.map((i) => i[key]);
	constructor(elm) {
		this.elm = elm;
		this.earliest.setDate(
			this.earliest.getDate() + +dansel.pickup_settings.soonest_pickup,
		);
		this.latest.setDate(
			this.latest.getDate() +
				+dansel.pickup_settings.max_pickup_days +
				+dansel.pickup_settings.soonest_pickup,
		); // 60 days in the future
		console.log(this);
		// make array of possible pickup dates for date Range
		this.elegibleDates = this.getDatesInrange(
			this.earliest,
			this.latest,
			1,
		);
		this.disableStoreClosedDates();
		// Loop over the products and determine the days/dates that we can pick up product
		let cartItems = document.querySelectorAll(
			".shop_table.pickup-dates .cart_item",
		);
		cartItems.forEach(this.findDateItems.bind(this));

		//		console.log('pickable', this.elegibleDates.filter(function (date) { return date.validPickup; }));
		let args = {};
		let earliestPickup = new Date(
			this.pluck(this.elegibleDates, "date")[0],
		);
		let calStart = new Date(
			earliestPickup.getFullYear(),
			earliestPickup.getMonth(),
			1,
		);
		switch (
			this.elegibleDates.filter(function (date) {
				return date.validPickup;
			}).length
		) {
			case 0:
				let placeholder = document.querySelector(this.elm);
				let warning = document.createElement("p");
				warning.innerHTML =
					"No pickup date can be specified as there are no dates on which all requested products are available. Delete 1 or more products from your cart (above)";
				warning.style =
					"text-decoration: underline; text-decoration-color: red;text-underline-offset: 8px;";
				placeholder.append(warning);
				return;
			/*
			case 1:
				let ct = new Date(this.pluck(this.elegibleDates, "date")[0]);
				let dayIndex = ct.getDay();
				let theDate = ct.toISOString().split("T")[0];
				console.log("one day only", dayIndex, theDate);
				// setup the date picker
				args = {
					timepicker: false,
					datepicker: true,
					format: "Y-m-d H:i",
					formatTime: "h:i a",
					dayOfWeekStart: 1,
					inline: true,
					startDate: calStart,
					yearStart: ct.getFullYear(),
					yearEnd: ct.getFullYear(),
					monthStart: ct.getMonth(),
					monthEnd: ct.getMonth(),
					prevButton: false,
					nextButton: false,

					formatTime: "g:i A",
					allowDates: this.pluck(this.elegibleDates, "date"),
					allowTimes: this.calculateStoreHours(dayIndex, theDate),
					onChangeDateTime: function (ct, $i) {
						if ("12:00:00 AM" == ct.toLocaleTimeString()) {
							return;
						}

						// Show the selected Pickup date & Time - release the credit card field
						let dateTarget = document.querySelector(
							"#selectedPickupDateTime > h3"
						);
						let headingTarget = document.querySelector(
							"#selectedPickupDateTime > h4"
						);
						headingTarget.style.display = "block";
						dateTarget.textContent =
							ct.toDateString() +
							" at " +
							ct.toLocaleString([], {
								hour: "2-digit",
								minute: "2-digit",
							});
						let dayIndex = ct.getDay();
						let theDate = ct.toISOString().split("T")[0];
						let storeHours = dansel.store_hours.normal_hours[
							dayIndex
						].map((x) =>
							new Date(x).toLocaleTimeString(["en-US"], {
								hour12: false,
								hour: "numeric",
								minute: "2-digit",
								timezone: "America/New_York",
							})
						);

						let found =
							dansel.store_hours.shortened_hours.findIndex(
								(x) => x.date === theDate
							);
						if (found > -1)
							storeHours = dansel.store_hours.shortened_hours[
								found
							].hours.map((x) =>
								new Date(x).toLocaleTimeString(["en-US"], {
									hour12: false,
									hour: "numeric",
									minute: "2-digit",
									timezone: "America/New_York",
								})
							);
						this.setOptions({
							allowTimes: storeHours,
							timepicker: true,
						});
						let checkoutButton =
							document.querySelector(".checkout-button");
						checkoutButton.textContent = "Proceed to Checkout";
						checkoutButton.dataset.pickupDateSet = "true";
						let pickupURL = new URL(
							checkoutButton.getAttribute("href")
						);
						pickupURL.searchParams.set(
							"dansel-set-pickup",
							ct.toLocaleString("en-US")
						);
						checkoutButton.setAttribute("href", pickupURL.href);
					},
				};

				let heading = document.getElementById("pickupdatepicker_title");
				heading.textContent =
					"Pickup Must Be On " + ct.toDateString() + ". Pick a Time";
				break;
                */
			default:
				// setup the date picker
				args = {
					timepicker: false,
					format: "Y-m-d H:i",
					formatTime: "h:i a",
					dayOfWeekStart: 1,
					//					defaultDate: this.pluck(this.elegibleDates, "date")[0],
					defaultTime: false,
					defaultSelect: false,

					inline: true,
					startDate: calStart,
					formatTime: "g:i A",
					allowDates: this.pluck(this.elegibleDates, "date"),
					yearStart: this.earliest.getFullYear(),
					yearEnd: this.latest.getFullYear(),
					monthStart: this.earliest.getMonth(),
					monthEnd: this.latest.getMonth(),
					onChangeMonth: function (currentTime, $el) {
						console.log(currentTime, $el);
					},
					onSelectTime(ct, something, el, e) {
						console.log("pickedTime", ct, something, el, e);
						return;
					},
					onSelectDate(ct, something, el, e) {},
					onChangeDateTime: function (ct, $i) {
						let dayIndex = ct.getDay();
						let theDate = ct.toISOString().split("T")[0];
						let storeHours = dansel.store_hours.normal_hours[
							dayIndex
						].map((x) =>
							new Date(x).toLocaleTimeString(["en-US"], {
								hour12: false,
								hour: "numeric",
								minute: "2-digit",
								timezone: "America/New_York",
							}),
						);

						let found =
							dansel.store_hours.shortened_hours.findIndex(
								(x) => x.date === theDate,
							);
						if (found > -1)
							storeHours = dansel.store_hours.shortened_hours[
								found
							].hours.map((x) =>
								new Date(x).toLocaleTimeString(["en-US"], {
									hour12: false,
									hour: "numeric",
									minute: "2-digit",
									timezone: "America/New_York",
								}),
							);
						this.setOptions({
							allowTimes: storeHours,
							timepicker: true,
						});
						console.log(
							ct,
							storeHours,
							dayIndex,
							dansel.store_hours.normal_hours,
							"-------------------",
							ct.getMinutes(),
							ct.getSeconds(),
							document.pickupLogic.latest.getMonth(),
							"/",
							ct.getMonth(),
						);
						if ("12:00:00 AM" == ct.toLocaleTimeString()) {
							return;
						}
						if (0 !== ct.getMinutes()) {
							return;
						}
						// Show the selected Pickup date & Time - release the credit card field
						let dateTarget = document.querySelector(
							"#selectedPickupDateTime > h3",
						);
						let headingTarget = document.querySelector(
							"#selectedPickupDateTime > h4",
						);
						headingTarget.style.display = "block";

						dateTarget.textContent =
							ct.toDateString() +
							" at " +
							ct.toLocaleString([], {
								hour: "2-digit",
								minute: "2-digit",
							});

						//@todo - Validate the selected date/time before releasing to complete checkout
						document.pickupLogic.releaseForCheckout(
							document.pickupLogic.earliest < ct &&
								document.pickupLogic.latest > ct,
							ct,
						);
					},
				};
		}
		let theDatePicker = jQuery("input", this.elm).datetimepicker(args);
	}
	releaseForCheckout(status, ct) {
		let checkoutButton = document.querySelector(".checkout-button");
		let pickupURL = new URL(checkoutButton.getAttribute("href"));
		if (status) {
			checkoutButton.textContent = "Proceed to Checkout";
			checkoutButton.dataset.pickupDateSet = "true";
			pickupURL.searchParams.set(
				"dansel-set-pickup",
				ct.toLocaleString("en-US"),
			);
			checkoutButton.setAttribute("href", pickupURL.href);
		} else {
			checkoutButton.textContent = "Select a Valid Pickup Date";
			checkoutButton.dataset.pickupDateSet = "false";
			pickupURL.searchParams.delete("dansel-set-pickup");
		}
	}
	calculateStoreHours(dayIndex, theDate) {
		let storeHours = dansel.store_hours.normal_hours[dayIndex].map((x) =>
			new Date(x).toLocaleTimeString(["en-US"], {
				hour12: false,
				hour: "numeric",
				minute: "2-digit",
				timezone: "America/New_York",
			}),
		);

		let found = dansel.store_hours.shortened_hours.findIndex(
			(x) => x.date === theDate,
		);
		if (found > -1)
			storeHours = dansel.store_hours.shortened_hours[found].hours.map(
				(x) =>
					new Date(x).toLocaleTimeString(["en-US"], {
						hour12: false,
						hour: "numeric",
						minute: "2-digit",
						timezone: "America/New_York",
					}),
			);
		return storeHours;
	}

	disableStoreClosedDates() {
		for (let i = 0; i < dansel.store_hours.closed.length; i++) {
			let found = this.elegibleDates.findIndex(
				(x) => x.date === this.formatYMD(dansel.store_hours.closed[i]),
			);
			if (found > -1) this.elegibleDates[found]["validPickup"] = false;
		}
	}

	getDatesInrange(d1, d2, interval) {
		var dates = [];
		let d1Clone = new Date(d1.getTime()); // since date objects are mutable in js
		while (+d1Clone < +d2) {
			const date = this.formatYMD(d1Clone);
			const validPickup = true;
			const dow = d1Clone.getDay();
			const timeStamp = d1Clone.setHours(12, 0, 0, 0);
			dates.push({ date, validPickup, dow, timeStamp });
			d1Clone.setDate(d1Clone.getDate() + interval);
		}
		return dates.slice(0);
	}

	disableDOWs(onlyPossibleDows) {
		return [0, 1, 2, 3, 4, 5, 6].filter(
			(x) => !onlyPossibleDows.includes(x),
		);
	}
	findDateItems(item) {
		//		console.log('/', item, this.elegibleDates);
		if ("availability_start" in item.dataset) {
			let start = new Date(item.dataset.availability_start).setHours(
				0,
				0,
				0,
				0,
			);
			let end = new Date(item.dataset.availability_end).setHours(
				23,
				59,
				59,
				0,
			);
			for (let i = 0; i < this.elegibleDates.length; i++) {
				if (!this.elegibleDates[i].validPickup) continue; // if already set to false, skip
				if (
					start <= this.elegibleDates[i].timeStamp &&
					this.elegibleDates[i].timeStamp <= end
				) {
					if ("available_days" in item.dataset) {
						let dow = JSON.parse(item.dataset.available_days);
						this.elegibleDates[i].validPickup = dow.includes(
							this.elegibleDates[i].dow,
						);
					}
				} else {
					this.elegibleDates[i].validPickup = false;
				}
			}
		}
		if ("specific_dates" in item.dataset) {
			let dates = JSON.parse(item.dataset.specific_dates).map((x) =>
				this.formatYMD(x),
			);
			for (let i = 0; i < this.elegibleDates.length; i++) {
				if (!this.elegibleDates[i].validPickup) continue;
				// does this elegible date exist in the array of permissible dates
				let found = dates.findIndex(
					(x) => this.elegibleDates[i].date == x,
				);
				if (found == -1) this.elegibleDates[i].validPickup = false;
			}
		}
	}

	formatYMD(dateString) {
		let d = new Date(dateString);
		let month = "" + (d.getMonth() + 1);
		let day = "" + d.getDate();
		let year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("/");
	}
}
